import { useMemo, useState } from 'react'
import instagramVerifiedImg from '../../assets/blog/instagramVerified.png'
import BlogFooter from '../../components/blog/Footer'
import BlogCreateDesignBanner from '../../components/BlogCreateDesignBanner'
import BlogEmailSubscription from '../../components/BlogEmailSubscription'
import BlogPostCard from '../../components/BlogPostCard'
import BlogSubscribePopup from '../../components/BlogSubscribePopup'
import BlogTabs from '../../components/BlogTabs'
import { useLastItemRef } from '../../hooks/useLastItemRef'
import { BlogContent, BlogView, BlogWidgets, CategoryInfo, HeaderWrapper, InstagramTitle, InstagramWidgetContainer, InstagramWidgetFrame } from './Blog.styles'

export const Blog = ({ pagination: prefetchedPagination, content, categories, activeCategory, featuredPost, searchMode, featureLine }) => {
  const [loading, setLoading] = useState(false)
  const [fetchedContent, setFetchedContent] = useState([])
  const [pagination, setPagination] = useState(prefetchedPagination)

  const loadMorePosts = async () => {
    if (loading) return

    const nextPage = pagination.page + 1

    if (nextPage > pagination.pageCount) {
      return
    }

    setLoading(true)

    const request = await fetch(`/api/blog?page=${pagination.page + 1}` + (activeCategory ? `&category=${activeCategory}` : ''))
    const response = await request.json()

    setFetchedContent([...fetchedContent, ...response.data])
    setPagination(response.meta.pagination)
    setLoading(false)
  }

  const lastItem = useLastItemRef(loadMorePosts)

  const selectedCategory = useMemo(() => categories.data.find(category => category.id === activeCategory), [categories, activeCategory])

  return (
    <>
      <BlogView>
        <HeaderWrapper>
          <BlogTabs categories={categories.data} active={activeCategory} />
          {/* {featureLine && (
            <FeatureLine
              bgColor={featureLine?.featureBgColor}
              textColor={featureLine?.featureTextColor}
              href={featureLine?.featureLink}
              onClick={() => {
                logEvent('blog_top_banner_click', {})
              }}
            >
              {featureLine?.featureTitle}
            </FeatureLine>
          )} */}
        </HeaderWrapper>
        {selectedCategory && (
          <CategoryInfo>
            <h1>{selectedCategory.attributes.title}</h1>
            {selectedCategory.attributes.description && <p>{selectedCategory.attributes.description}</p>}
          </CategoryInfo>
        )}
        <BlogContent>
          {searchMode && content.length === 0 && <p>No results found</p>}
          {!searchMode && !activeCategory && <BlogPostCard huge={true} post={featuredPost.attributes} />}
          {content.map((post, index) => (
            <BlogPostCard key={post.id} refFn={lastItem} huge={activeCategory ? pagination.page > 1 && index === 0 : false} post={post.attributes} />
          ))}
          {fetchedContent.map((post, index) => (
            <BlogPostCard key={post.id} refFn={lastItem} huge={false} post={post.attributes} />
          ))}
        </BlogContent>
        <BlogCreateDesignBanner />
        <BlogWidgets topSpacing>
          <BlogEmailSubscription withBackground />
          <InstagramWidgetContainer>
            <InstagramTitle>
              @decormattersapp <img src={instagramVerifiedImg} alt="Verified Account" />
            </InstagramTitle>
            <InstagramWidgetFrame src="https://cdn.lightwidget.com/widgets/783395cca0b35d0a9d46c02164d75f30.html" scrolling="yes" allowtransparency="true" />
          </InstagramWidgetContainer>
        </BlogWidgets>
        <BlogFooter />
      </BlogView>
      <BlogSubscribePopup />
    </>
  )
}
